import { render, staticRenderFns } from "./efficiency-class-bars.vue?vue&type=template&id=bf9fe8f4&"
import script from "./efficiency-class-bars.vue?vue&type=script&lang=js&"
export * from "./efficiency-class-bars.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports